import { isEmpty } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { FlexCol } from '../../../../components/structure/FlexGrid'
import { useNonCompliancesReplies } from './_data/nonCompliancesReplies'
import Accordion from '../../../../components/structure/Accordion'
import DynamicListCounters from '../../../../containers/dynamic/presentationList/DynamicListCounters'
import DynamicPresentationList from '../../../../containers/dynamic/presentationList/DynamicPresentationList'

const NonCompliancesAccordion = () => {
  const { t } = useTranslation('serviceOrders')

  const replies = useNonCompliancesReplies()
  if (isEmpty(replies)) return false

  return (
    <FlexCol>
      <Accordion label={t('indicators.nonCompliances')} side={<DynamicListCounters replies={replies} />}>
        <DynamicPresentationList replies={replies} ignoreFilter />
      </Accordion>
    </FlexCol>
  )
}

export default NonCompliancesAccordion
